import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const PrivateRoute = ({component: Component, ...rest}) => {
    const token = localStorage.getItem('bwSpotifyToken')
    
    return (
        <Route {...rest} render={() => {
            if (token){
                return <Component />
            } else {
                return <Redirect to='/login'/>
            }
        }} 
        />
    )
}

export default PrivateRoute